export async function sleep(ms = 1000): Promise<typeof setTimeout> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function addScript(
  attributes: Record<string, string>,
  text?: string,
  callback?: () => void,
  node = "body"
): void {
  const s = document.createElement("script");
  for (const attr in attributes) {
    s.setAttribute(attr, attributes[attr] ? attributes[attr] : null);
  }

  if (text) s.innerHTML = text;
  if (callback) s.onload = callback;
  document[node].appendChild(s);
}

/* todo: maybe refactor later with generic arguments type */
type BrowserFunction<T> = (...args: any) => T;
export function runInBrowserOnly<T>(f: BrowserFunction<T>): BrowserFunction<T> {
  return function (...rest): T {
    if (typeof window === "undefined") return;
    return f.apply(this, rest);
  };
}
type AsyncBrowserFunction<T> = () => Promise<T>;
export function runInBrowserOnlyAsync<T>(
  f: () => Promise<T>
): AsyncBrowserFunction<T> {
  return async function (...args): Promise<T> {
    if (typeof window === "undefined") return;
    return f.apply(this, args);
  };
}
